module.exports = __webpack_public_path__ + "img/cropped-favicon_las-1.83c23d03.png";